import throttle from 'lodash/throttle';
window.hatchery = window.hatchery ?? {};
window.hatchery.navbar = window.hatchery.navbar ?? {};
/**
 * Config
 */
const minDisappearDelta = 30;
const minShrinkPageOffset = 40;
// Get reference to all menu components
const navToggle = document.getElementById('nav-toggle');
const navContainer = document.getElementById('navbar');
const navListContainer = navContainer?.querySelector('nav');
const navLinks = document.querySelectorAll('.nav-link');
// Get navbar settings
const enableShrink = navContainer?.hasAttribute('data-enable-shrink');
const enableDisappear = navContainer?.hasAttribute('data-enable-disappear');
function setMenuOpen(open) {
    const navToggleClass = 'is-active';
    const navContainerClass = 'open';
    if (open === true) {
        // Add all
        navToggle?.classList.add(navToggleClass);
        navContainer?.classList.add(navContainerClass);
        document.body.style.overflow = 'hidden';
    }
    else if (open === false) {
        // Remove all
        navToggle?.classList.remove(navToggleClass);
        navContainer?.classList.remove(navContainerClass);
        document.body.style.overflow = 'visible';
    }
    else {
        // Nothing was set, simply toggle current state
        const wasOpen = navToggle?.classList.contains(navToggleClass);
        navToggle?.classList.toggle(navToggleClass);
        navContainer?.classList.toggle(navContainerClass);
        document.body.style.overflow = wasOpen ? 'visible' : 'hidden';
    }
}
export function openMenu() {
    setMenuOpen(true);
}
export function closeMenu() {
    setMenuOpen(false);
}
export function toggleMenu() {
    setMenuOpen();
}
let lastScrollTop = 0;
/**
 * Updates the status of the navbar
 */
function updateNavbarState() {
    const distanceToTop = window.pageYOffset;
    if (distanceToTop > minShrinkPageOffset && enableShrink) {
        navContainer?.classList.add('is-shrinked');
    }
    else {
        navContainer?.classList.remove('is-shrinked');
    }
    const difference = Math.abs(lastScrollTop - distanceToTop);
    if (difference >= minDisappearDelta) {
        if (distanceToTop > lastScrollTop && distanceToTop > minShrinkPageOffset && enableDisappear) {
            // User scrolled down
            navContainer?.classList.add('is-disappeared');
        }
        else {
            // User scrolled up
            navContainer?.classList.remove('is-disappeared');
        }
        lastScrollTop = distanceToTop;
    }
}
export function hideNavbar() {
    navContainer?.classList.add('is-disappeared');
}
export function showNavbar() {
    navContainer?.classList.remove('is-disappeared');
}
updateNavbarState();
// Append listeners
if (window.hatchery.navbar.initialized !== true) {
    window.hatchery.navbar.initialized = true;
    // Open / close menu
    navToggle?.addEventListener('click', () => toggleMenu());
    // Close menu on link-click
    Array.from(navLinks).forEach(navLink => {
        navLink.addEventListener('click', () => closeMenu());
    });
    // Close the menu on window resize
    window.addEventListener('resize', () => {
        if (navListContainer?.clientHeight) {
            if (navListContainer.clientHeight / window.innerHeight < 0.33) {
                // Nav container is smaller, that means the desktop breakpoint was hit, menu should be closed
                closeMenu();
            }
        }
    });
    window.addEventListener('load', () => {
        window.addEventListener('scroll', throttle(updateNavbarState, 100));
    });
}
